import React, { useState, useEffect } from 'react'
import { useCompany, useProfile, useUser } from 'models';
import { useLocation, useHistory, Link } from "react-router-dom";
import ActionRequestService from 'services/action-request';
import NavBar from 'components/NavBar';
import { Button, Col, Row, Card, Tooltip, Container, OverlayTrigger, Form } from 'react-bootstrap';
import { Add, ArrowBackIos, Description, WidgetsOutlined } from '@material-ui/icons';
import Can from 'components/Can';
import ActionList from "./List"
import AdminRequestService from 'services/admin-request';
import { fiscalYearsList } from 'helpers';

export default function () {
  const user = useUser();
  const profile = useProfile()

  const location = useLocation();
  const { fy } = location.state || {};
  // console.log(fy)
  const { company: currentCompany } = useCompany()

  const [fiscalYears] = useState(() => {
    return fiscalYearsList(currentCompany, user, profile).filter(a=>a.id == 13);
  })

  const [status, setStatus] = useState([]);
  const [countActions, setCountActions] = useState([]);
  const [flowSelected, setFlowSelected] = useState(1);

  // controle de verificacao se pode adicionar mais acao
  // esse controle é feito pela api e retorna depois
  const [verify_add_more, set_verify_add_more] = useState(false);

  const history = useHistory();
  const [fiscalYear, setFiscalYear] = useState(!!fy?fiscalYears.filter(a=>a.id == fy)[0]:fiscalYears[0]);
  const [currentFiscalYear] = useState([...user.fiscal_years].reverse()[0]);

  useEffect(() => {
    AdminRequestService.verifyAddMoreAction(currentCompany ? currentCompany.id : null).then(() => {
      set_verify_add_more(true)
    }).catch(() => {
      set_verify_add_more(false)
    })
    getFlows();
    getActions(fiscalYear.id);
  }, [currentCompany, fiscalYear]);

  const getFlows = () => {
    let request = ActionRequestService.getFlow(5);
    request.then((data) => {
      let r = data.data.data;
      r.user_steps = [];
      if (user.profile.steps)
        user.profile.steps.forEach((step) => {
          if (r.id === step.flow_id) {
            r.user_steps[step.id] = step;
          }
        });
      setStatus(Object.values(r.action_status));
    });
  };

  const getProfile = () => {
    return user.profile
  };

  const getActions = (fiscal_year_id = null, company_id = null) => {
    var filter = {
      fiscal_year_id: fiscal_year_id ?? fiscalYear,
      __fund_type_id: 5,
      company_id: company_id ?? currentCompany ? currentCompany.id : null
    };

    ActionRequestService.amountByStatus({ params: { ...filter } }).then(
      (data) => {
        setCountActions(data.data.data);
      }
    );
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Período de bloqueio para solicitação de novas ações. A partir do dia
      primeiro do mês seguinte o sistema será reaberto para novas solicitações.
      Dúvidas consulte a seção de Perguntas e Respostas (FAQ).
    </Tooltip>
  );

  const orderStatusByPosition = arr => arr.sort((a, b) => a.position - b.position)

  function verifyAdhesion() {
    // if(currentCompany);
    return
  }

  const btnadd = () => {
    return (
      <Can do="scancash.create" on="App">
        {/* 
          teste de periodo ou de perfil
          caso esteja fpra do periodo ou diferente de adm ele faz outra verificacao
          caso contrario mostra o botao
        */}
        {(!verify_add_more && getProfile() != 'Administrador') ? (<>
          {/* 
            verificacao se tem permissao de add fora do periodo
            caso tenha mostra o botao, caso nao bloqueia
            * tinha uma verificacao de mes 12, caso fosse deixava passar tambem, nao sei o pq
          */}
          {profile.havePermission("action.add-out-period") ? (
            <Link to="/elite/elite-pass/show">
              <Button className="btn-add">
                <Add /> Solicitar Resgate
              </Button>
            </Link>
          ) : (
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip}
            >
              <Button
                variant="light"
                onClick={(e) => {
                  e.target.className = e.target.className.replace(
                    'btn-light',
                    'btn-reject btn-danger'
                  );
                  const parar = () => {
                    let element = document.getElementsByClassName(
                      'btn-reject'
                    )[0];
                    if (element)
                      element.className = element.className.replace(
                        'btn-reject btn-danger',
                        'btn-light'
                      );
                  };
                  window.setTimeout(parar, 500);
                }}
              >
                <Add />
                Solicitar Resgate
              </Button>
            </OverlayTrigger>
          )}
        </>) : (<>
          <Link to={{
            pathname:"/elite/elite-pass/show",
            state:{fy:fiscalYear.id}
          }}>
            <Button className="btn-add">
              <Add /> Solicitar Resgate
            </Button>
          </Link>
        </>)}
      </Can>
    );
  }

  return (
    <Container fluid>
      <Row className="mt-4">
        <Button variant="link" className="link-back" onClick={() => history.goBack()}>
          <ArrowBackIos className="icon-title icon-back" />
          <h6 className="font-13 mt-3">Voltar</h6>
        </Button>
      </Row>
      <Row className="mt-3 align-items-center justify-content-between">
        <Col className='d-flex'>
          <WidgetsOutlined className="icon-title" />
          <h5>Fluxo de Elite Pass</h5>
        </Col>
        {fiscalYears.length > 1 ? (
          <Col xs="auto">
            <Form.Control value={fiscalYear.id} size='sm' as="select" onChange={(e) => {
              const fy = fiscalYears.filter(fy => fy.id == e.target.value)[0]
              setFiscalYear(fy)
            }}>
              {fiscalYears.map((fy, idx) => (
                <option key={idx} value={fy.id}>{fy.fiscal_year}</option>
              ))}
            </Form.Control>
          </Col>
        ) : <></>}
      </Row>
      <Row>
        <Card.Body className="card-dashboard shadow bg-white rounded text-center m-2 col-12">
          <Row className="mt-2 mb-2">
            <Col xs='12' md='6' className="text-left">
              {btnadd()}
              {currentCompany && (
                <Link to="/elite/elite-pass/fund">
                  <Button className='ml-2'>
                    <Description /> Extrato de Verbas
                  </Button>
                </Link>
              )}
              <Can on="App" do="scancash.deductions">
                <Link to="/elite/deductions">
                  <Button variant='info' className='ml-2'>
                    <Description /> Deduções
                  </Button>
                </Link>
              </Can>
            </Col>
          </Row>
          <Row>
            <Col xs="12">
              <NavBar addAll onChange={(key) => {
                setFlowSelected(key)
              }}>
                {orderStatusByPosition(status).map((item, k) => {
                  let quantity = countActions[item.id] ? countActions[item.id].amount : 0;
                  let list = [6, 7, 11]
                  return (
                    <NavBar.Item
                      key={k}
                      eventKey={item.id}
                      title={item.name}
                      quantity={quantity}
                      hiddenEmpty={list.indexOf(item.id) !== -1}
                    />
                  )
                })}
              </NavBar>
            </Col>
          </Row>
          <ActionList
            currentCompany={currentCompany}
            flowSelected={flowSelected}
            fiscalYear={fiscalYear.id}
          />
        </Card.Body>
      </Row>
    </Container>
  );
}